import { MapPin, Layers3, BarChart3 } from "lucide-react";

interface TrustBadgesProps {
  variant?: "light" | "dark";
  className?: string;
  showLogos?: boolean;
}

const TrustBadges = ({ variant = "light", className = "", showLogos = false }: TrustBadgesProps) => {
  const textColor = variant === "light" ? "text-muted-foreground" : "text-primary-foreground/80";
  const iconColor = variant === "light" ? "text-primary" : "text-accent";
  const bgColor = variant === "light" ? "bg-muted/50" : "bg-white/10";

  const badges = [
    { icon: MapPin, text: "Michigan-based" },
    { icon: Layers3, text: "Full-service team" },
    { icon: BarChart3, text: "Transparent reporting" }
  ];

  return (
    <ul role="list" className={`flex flex-wrap items-center justify-center gap-4 md:gap-6 ${className}`}>
      {badges.map((badge, index) => (
        <li key={index} className={`flex items-center gap-2 group cursor-default ${showLogos ? `${bgColor} px-4 py-2 rounded-full` : ""}`}>
          <badge.icon className={`h-4 w-4 ${iconColor} transition-all duration-300 group-hover:scale-110 group-hover:rotate-6`} aria-hidden="true" />
          <span className={`text-sm font-medium ${textColor} transition-colors duration-300`}>{badge.text}</span>
          {index < badges.length - 1 && (
            <span className={`hidden md:inline ml-4 ${textColor} opacity-50`} aria-hidden="true">|</span>
          )}
        </li>
      ))}
    </ul>
  );
};

export default TrustBadges;
